import { render, staticRenderFns } from "./ProductSaleStatistics.vue?vue&type=template&id=3cc035db"
import script from "./ProductSaleStatistics.vue?vue&type=script&lang=js"
export * from "./ProductSaleStatistics.vue?vue&type=script&lang=js"
import style0 from "./ProductSaleStatistics.vue?vue&type=style&index=0&id=3cc035db&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports